import React, { useEffect, useState } from "react";
import { DeleteForever } from "@mui/icons-material";
import { toast } from "react-toastify";
import SimpleModal from "../../../../components/SimpleModal/SimpleModal";
import { Colors } from "../../../../constants/Colors";
import { deleteVehicleEffect } from "../../../../stores/VehiclesStore/VehiclesStore.effects";
import { Vehicle } from "../../../../types/vehicles.types";

interface Props {
  vehicle: Vehicle;
}

const DeleteVehicle: React.FC<Props> = ({ vehicle }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;

    const unsubscribeDone = deleteVehicleEffect.doneData.watch(() => {
      toast.success("Veículo deletado com sucesso!");
      setOpen(false);
    });
    const unsubscribeFail = deleteVehicleEffect.fail.watch(() => {
      toast.error("Erro ao deletar veículo!");
    });

    return () => {
      unsubscribeDone();
      unsubscribeFail();
    };
  }, [open]);

  return (
    <SimpleModal
      open={open}
      setOpen={setOpen}
      Component={
        <DeleteForever
          sx={{ color: Colors.secondary[100], ":hover": { opacity: "70%" }, cursor: "pointer" }}
        />
      }
      onConfirm={() => deleteVehicleEffect({ id: vehicle.id, isFleet: true })}
      title="Deletar veículo"
      text={`Confirma deletar o veículo ${vehicle.licencePlate}?`}
      confirmText="Deletar"
      cancelText="Cancelar"
    />
  );
};

export default DeleteVehicle;
